const shareResourcePreferenceKey = 'readingPlan.shareResourcesWithParticipants';

export const getShareResourcesWithParticipantsDefault = () => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(shareResourcePreferenceKey) === 'true';
};

export const setShareResourcesWithParticipantsDefault = value => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(shareResourcePreferenceKey, value ? 'true' : 'false');
};
